export const EXSBWAREHOUSETYPE_DELETE_RESET = 'EXSBWAREHOUSETYPE_DELETE_RESET'
export const EXSBWAREHOUSETYPE_DELETE_SET_ERROR = 'EXSBWAREHOUSETYPE_DELETE_SET_ERROR'
export const EXSBWAREHOUSETYPE_DELETE_SET_DELETED = 'EXSBWAREHOUSETYPE_DELETE_SET_DELETED'
export const EXSBWAREHOUSETYPE_DELETE_TOGGLE_LOADING = 'EXSBWAREHOUSETYPE_DELETE_TOGGLE_LOADING'
